import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

export const PostClosingConditionMenuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" ry="2" fill="currentColor" />
    <text
      x="12"
      y="15"
      fontSize="7"
      fontWeight="bold"
      textAnchor="middle"
      fill="white"
      fontFamily="Arial, sans-serif"
    >
      PC
    </text>
  </SvgIcon>
);
